module.exports = __webpack_public_path__ + "img/circle_green.3fa22bb2.svg";